export default __webpack_public_path__ + "static/media/pyretlogo.a4a1c6c4.png";